import { render } from "./DeniedTrialModal.vue?vue&type=template&id=33850031"
import script from "./DeniedTrialModal.vue?vue&type=script&lang=js"
export * from "./DeniedTrialModal.vue?vue&type=script&lang=js"

import "./DeniedTrialModal.vue?vue&type=style&index=0&id=33850031&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__